import _ from 'lodash';
import Validator from 'validatorjs';
import React, { Component } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { FormControl } from '../../../../../facturotopia';
import CartaPorteDomicilioForm from './CartaPorteDomicilioForm';
import CartaPorteCatalogoManager from '../../../../catalogs/managers/CartaPorteCatalogoManager';
import CartaPorteTiposFiguraPartesTransporteManager from './CartaPorteTiposFiguraPartesTransporteManager';
import CartaPorteClienteManager from '../../../../catalogs/managers/CartaPorteClienteManager';

class CartaPorteTiposFiguraForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      isValid: false,
      isValidAddress: false,
      isTouchedDomicilio: false,
      validator: new Validator({}, this.rules({})),
    };
  }

  componentDidMount() {
    const figuraTransporte = CartaPorteCatalogoManager.get('c_cp_figura_transporte');

    const { operadores } = CartaPorteClienteManager.get('carta-porte');

    let catalogos = {};

    catalogos.figuraTransporte = this.getCatalogo(figuraTransporte);
    catalogos.ClienteFiguraTransporte = this.getSortedCatalogoCliente(operadores, 'nombre_del_operador', 'nombre_del_operador');

    this.setState({
        catalogos
      });
  }

  componentDidUpdate() {
    const { data } = this.props;

    if (!!data) {
      this.setState({
        data: { ...data },
        partesTransporteChecked: !!data.PartesTransporte,
        isValid: true
      });
    }
  }

  rules(data) {
    return {
      'TipoFigura': ['required','string'],
      'RFCFigura': ['required','string', 'min:12', 'max:13', 'regex:/^[A-Z&Ñ]{3,4}[0-9]{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])[A-Z0-9]{2}[0-9A]$/'],
      'NumLicencia': ['string', 'min:6', 'max:16'],
      'NombreFigura': ['string', 'min:1', 'max:254'],
      'NumRegIdTribFigura': ['string', 'min:6', 'max:40'],
      'ResidenciaFiscalFigura': ['string'],
    }
  }

  getCatalogo = (values) => {
    if (!!values) {
      const sorted = _.sortBy(values.map((item) => {
        return {
          label: item.descripcion,
          value: item.clave
        }
      }), 'label');

      return [
        {
          label: 'Selecciona',
          value: ''
        }
      ].concat(sorted);
    }
  }

  getSortedCatalogoCliente = (values, label, id) => {
    if (!values) {
      return [];
    }

    return _.sortBy(values.map((item) => {
      return {
        label: `${item.rfc_del_operador} - ${item[label]}`,
        value: item[id],
        clave_figura_transporte: item.clave_figura_transporte,
        concepto_figura_transporte: item.concepto_figura_transporte,
        rfc_del_operador: item.rfc_del_operador,
        nombre_del_operador: item.nombre_del_operador,
        numero_de_licencia: item.numero_de_licencia,
        numero_registro_fiscal: item.numero_registro_fiscal,
        residencia_fiscal: item.residencia_fiscal,
        calle: item.calle,
        numero_exterior: item.numero_exterior,
        numero_interior: item.numero_interior,
        colonia: item.colonia,
        localidad: item.localidad,
        referencia: item.referencia,
        municipio: item.municipio,
        c_estado: item.c_estado,
        estado: item.estado,
        pais: item.pais,
        codigo_postal: item.codigo_postal
      }
    }), 'nombre_del_operador');
  }

  handleOnFiguraTransporteChange = (value) => {
    let data = {
      ...this.state.data,
      ...value,
    }

    if (!_.isEmpty(value)) {
      data = {
          ...this.state.data,
          ClienteFiguraTransporte: value.nombre_del_operador.toString(),
          TipoFigura: value.clave_figura_transporte.toString(),
          RFCFigura: value.rfc_del_operador.toString(),
          NumLicencia: value.numero_de_licencia.toString(),
          NombreFigura: value.nombre_del_operador.toString(),
          NumRegIdTribFigura: value.numero_registro_fiscal.toString(),
          ResidenciaFiscalFigura: value.residencia_fiscal.toString(),
          Domicilio: {
            Calle: value.calle.toString(),
            NumeroExterior: value.numero_exterior.toString(),
            NumeroInterior: value.numero_interior.toString(),
            Colonia: value.colonia.toString(),
            Localidad: value.localidad.toString(),
            Referencia: value.referencia.toString(),
            Municipio: value.municipio.toString(),
            Estado: value.c_estado.toString(),
            Pais: value.pais.toString(),
            CodigoPostal: value.codigo_postal.toString(),
          },
      };
    }

    this.handleOnChange(data);
  }

  validate(data) {
    const validator = new Validator(data, this.rules(data));

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnChange = (value) => {
    const data = {
      ...this.state.data,
      ...value
    }

    const validator = this.validate(data);

    this.setState({
      data,
      isValid: validator.passes(),
    });
  }

  handleOnAdd = () => {
    this.props.onAdd(this.state.data);

    this.setState({
      isValid: false,
      partesTransporteChecked: false,
      data: {}
    })
  }

  handleOnAdditionalCheckboxChange = (event) => {
    const { name, checked } = event.target;

    this.setState({
      [name]: checked,
    });
  }

  handleOnAdditionalChange = (additional) => {
    this.setState({
      data: {
        ...this.state.data,
        ...additional
      }
    });
  }

  handleOnDomicilioDataChange = (event) => {
    const data = {
      ...this.state.data.Domicilio,
      ...event.data,
    }

    this.setState({
      data: {
        ...this.state.data,
        Domicilio: data,
      },
      isValidAddress: event.isValid,
      isTouchedDomicilio: event.isTouched
    });
  }

  handleOnRefreshData = () => {
    this.setState({
      isValid: false,
      partesTransporteChecked: false,
      data: {}
    })
  }

  render() {
    const rules = this.rules();
    const {
      isValid,
      isValidAddress,
      isTouchedDomicilio,
      partesTransporteChecked,
      data = {},
      catalogos = {}
    } = this.state;

    return (
      <>

        <Row className="pb-2">
          <Col sm md={ 11 }>
            <FormControl type="ahead"
              label="Catálogo Figuras Transporte"
              id="ClienteFiguraTransporte"
              name="ClienteFiguraTransporte"
              help=""
              value={ data.ClienteFiguraTransporte }
              placeholder={ data.ClienteFiguraTransporte }
              options={ catalogos.ClienteFiguraTransporte }
              onSelect={ this.handleOnFiguraTransporteChange }
            />
          </Col>

          <Col sm md={ 1 } className="text-right" style={ { marginTop: "28px" } }>
            <Button
              size="lg"
              variant="secondary"
              onClick={ this.handleOnRefreshData }
            >
              <FontAwesomeIcon icon={ ['fas', 'trash'] } />
            </Button>
          </Col>
        </Row>

        <Row>
          <Col sm md={ 4 }>
            <FormControl type="select"
              label="Tipo Figura"
              name="TipoFigura"
              placeholder=""
              help=""
              rules={ rules.TipoFigura }
              value={ data.TipoFigura }
              options={ catalogos.figuraTransporte }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="text"
              label="RFC Figura"
              name="RFCFigura"
              placeholder=""
              casing={ 'upper' }
              help=""
              minLength="12"
              maxLength="13"
              rules={ rules.RFCFigura }
              value={ data.RFCFigura }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="text"
              label="Número de Licencia"
              name="NumLicencia"
              placeholder=""
              help=""
              minLength="6"
              maxLength="16"
              rules={ rules.NumLicencia }
              value={ data.NumLicencia }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="text"
              label="Nombre Figura"
              name="NombreFigura"
              placeholder=""
              help=""
              minLength="1"
              maxLength="254"
              rules={ rules.NombreFigura }
              value={ data.NombreFigura }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="text"
              label="Número Registro ID Tributario Figura"
              name="NumRegIdTribFigura"
              placeholder=""
              help=""
              minLength="6"
              maxLength="40"
              rules={ rules.NumRegIdTribFigura }
              value={ data.NumRegIdTribFigura }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="text"
              label="Residencia Fiscal Figura"
              name="ResidenciaFiscalFigura"
              placeholder=""
              casing={ 'upper' }
              help=""
              minLength="3"
              maxLength="3"
              rules={ rules.ResidenciaFiscalFigura }
              value={ data.ResidenciaFiscalFigura }
              // options={ }
              onChange={ this.handleOnChange }
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <strong>Domicilio Figura</strong>
          </Col>
        </Row>

        <CartaPorteDomicilioForm
          data={ data.Domicilio || {} }
          onFormDataChange={ this.handleOnDomicilioDataChange }
        />

        <Row>
          <Col>
            <p className="text-muted">
              Puedes agregar varias Figura Transporte usando el botón "Agregar Figura", la lista se mostrarán en la tabla de FiguraTransporte.
            </p>
          </Col>
        </Row>

        <Row>
          <Col>
            <Form.Group controlId="partesTransporteChecked">
              <Form.Check type="checkbox"
                name="partesTransporteChecked"
                label="Incluir Partes Transpote"
                checked={ partesTransporteChecked || false }
                onChange={ this.handleOnAdditionalCheckboxChange }
              />
            </Form.Group>
          </Col>
        </Row>

        { !!partesTransporteChecked && (
          <CartaPorteTiposFiguraPartesTransporteManager
            data={ data }
            onChange={ this.handleOnAdditionalChange }
          />
        )}

        <Row className="pt-3">
          <Col className="text-right">
            <Button variant="secondary"
              disabled={ !isValid || (!isValidAddress && isTouchedDomicilio) }
              onClick={ this.handleOnAdd }
            >
              Agregar Figura
            </Button>
          </Col>
        </Row>
      </>
    )
  }
}

export default CartaPorteTiposFiguraForm;